














































import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import EventFeed from './EventFeed'

settings =
  name: "CampaignEventFeed"

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'

    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'

  vue:
    props: ['resourceSlug']
    components: { Back, EventFeed }

    computed:
      campaignId: -> @$route.params.campaignId
      tab: -> @$route.params.tab
      summary: -> @cart?.summary || {}

    watch:
      tab: -> @fetch('campaign')

export default VueOptions.vue settings
